export const variableHelpText =
  'Supports <a href="https://help.thinkpickle.com.au/flows/variables" target="_blank" rel="noopener noreferrer">variables</a>'
export const variableHelpTextSmall =
  'Supports <a href="https://help.thinkpickle.com.au/flows/variables" target="_blank" rel="noopener noreferrer">vars</a>'



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/utils/variableHelpText.js